import { motion } from "framer-motion";

const prerendered = typeof window !== "undefined" && window.__PRERENDERED;

export const Reveal = ({ children, delay = 0, className = "", y = 24 }) => (
  <motion.div
    initial={prerendered ? false : { opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "", light = false }) => (
  <span
    className={`text-xs font-semibold uppercase tracking-[0.22em] ${
      light ? "text-gold" : "text-forest"
    } ${className}`}
  >
    {children}
  </span>
);
